import { createSlice } from '@reduxjs/toolkit';
import { API_USERS } from 'constants/api';
import { dispatch } from '../index';
import axiosServices from 'utils/axios';

const initialState = {
    error: null,
    usersPaginated: {
        data: [],
        count: 0
    }
};

export const slice = createSlice({
    name: 'apiuser',
    initialState,
    reducers: {
        // HAS ERROR
        hasError(state, action) {
            state.error = action.payload;
        },

        // GET ALL USERS
        setAllApiUsersPaginated(state, action) {
            state.usersPaginated = action.payload;
        }
    }
});

// Reducer
export default slice.reducer;

export const fetchAllApiUsersPaginated = async ({ startIndex, stopIndex, query, sortDirection, sortBy, dateFrom, dateTo } = {}) => {
    try {
        const data = {
            startIndex,
            stopIndex,
            query,
            sortBy,
            sortDirection,
            dateFrom,
            dateTo
        };
        const response = await axiosServices.get(API_USERS.v1.fetchAll, { params: { ...data, queryString: query } });
        const users = { data: response.data?.data, count: response.data?.pagination.count };
        dispatch(slice.actions.setAllApiUsersPaginated(users));
    } catch (err) {
        console.error('Error fetching api users:', err);
    }
};

export function createApiUser(user) {
    return async () => {
        try {
            const response = await axiosServices.post(API_USERS.v1.create, { ...user });
            const result = response.data;
            return {
                success: result.success,
                msg: result.success ? 'API User created successfully' : result.message
            };
        } catch (err) {
            console.error('Error creating API users:', err);
            return { sucess: false, msg: err?.message || 'Error creating API user.' };
        }
    };
}

export function updateApiUser(userId, userDetails) {
    return async () => {
        try {
            const response = await axiosServices.put(`${API_USERS.v1.create}/${userId}`, { ...userDetails });
            const result = response.data;
            return {
                success: result.success,
                msg: result.success ? 'API User updated successfully' : result.message
            };
        } catch (err) {
            console.error('Error updating api users:', err);
            return { success: false, msg: err?.message || 'Error updating api user.' };
        }
    };
}
